import {useRoute} from './RouterProvider';
import {createElement} from '../../utils/component';

const Route = props => {
    const route = useRoute();
    const {component} = route || {};
    return component ? createElement(component) : null;
};

export default Route;